<form *ngIf="addEditForm && validation" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}"
  (ngSubmit)="saveOrUpdate(dialogCategoryGift)" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty">
    <div class="ui-grid-row bottom-12-margin">
      <!-- Codice -->
      <div class="ui-grid-col-4">
        <span class="label" [ngClass]="{'required': !validation.code.nullable}">{{ validation.code.keyName }}</span>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" pInputText class="fieldInput" formControlName="code" required="true" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.code">
          error</app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-12-margin">
      <!-- Descrizione -->
      <div class="ui-grid-col-4">
        <span class="label" [ngClass]="{'required': !validation.description.nullable}">{{ validation.description.keyName }} </span>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" pInputText class="fieldInput" formControlName="description" required="true" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm"
          [validation]="validation.description">error</app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-12-margin">
      <!-- Ordinamento -->
      <div class="ui-grid-col-4">
        <span class="label" [ngClass]="{'required': !validation.progres.nullable}">{{ validation.progres.keyName }} </span>
      </div>
      <div class="ui-grid-col-8">
        <input type="number" pInputText class="fieldInput" formControlName="progres" required="true" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm"
          [validation]="validation.progres">error</app-validation-msg>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"
      style="display: flex; justify-content: center; border: 0;">
      <button pButton class="k-generic-btn" type="submit" icon="fa fa-check" iconPos="left"
        label="{{dialogCategoryGift.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'customerShoppingHabits.category' | translate}}">
      </button>
    </div>
  </p-footer>
</form>
  


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-category/loyalty-catalog-category-form/loyalty-catalog-category-form.component.html